import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import type { ChildRoute } from './routesConfig';
import { routesConfig } from './routesConfig';

export function AppRoutes() {
  return (
    <Routes>
      {routesConfig.map(({ Layout, routes }) =>
        routes.map(({ path, element, children }) => {
          if (children) {
            return (
              <Route
                key={path}
                path={path}
                element={
                  <Layout>
                    <Outlet />
                  </Layout>
                }
              >
                {children.map((child: ChildRoute) =>
                  child.index ? (
                    <Route key="index" index element={<Navigate to={child.redirect} replace />} />
                  ) : (
                    <Route key={child.path} path={child.path} element={child.element} />
                  ),
                )}
              </Route>
            );
          }
          return <Route key={path} path={path} element={<Layout>{element}</Layout>} />;
        }),
      )}
    </Routes>
  );
}
